// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"645":"fc89c488","737":"177a16d6","794":"e86536ac","867":"bb467cbb","873":"4f2d8e73","908":"89eecc96","925":"34058a17","952":"1b377872"}[chunkId] + ".chunk.css";
};